const Cookies = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-black uppercase italic">Política de Cookies</h1>

      <p>
        Este sitio web utiliza cookies propias y de terceros para mejorar la experiencia del usuario y analizar la navegación.
      </p>

      <p>
        Las cookies son pequeños archivos que se almacenan en el dispositivo del usuario y permiten reconocerlo en futuras visitas.
      </p>

      <p>
        El usuario puede configurar o rechazar las cookies a través de la configuración de su navegador.
      </p>

      <p>
        Al continuar navegando por este sitio web, se entiende que acepta el uso de cookies.
      </p>
    </div>
  );
};

export default Cookies;
